import React, { useState } from 'react';
import { Row, Col, Card, Button, Spinner, Form } from 'react-bootstrap';
import { toast } from 'react-toastify';

import { usePrinterService } from '../../../common/hooks/usePrinterService';

export const NovCommandCard: React.FC = () => {
  const [novCommand, setNovCommand] = useState('');
  const [novReply, setNovReply] = useState('');
  const [novReplyText, setNovReplyText] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const printerService = usePrinterService();

  const handleSend = async () => {
    if (!novCommand.trim()) {
      toast.error('Proszę wpisać polecenie NOVITUS');
      return;
    }
    setIsLoading(true);
    try {
      const hexCommand = printerService.buildNovitusPacket(novCommand.trim());
      const result = await printerService.sendNovCommand(hexCommand);
      if (result.packet?.value) {
        const { hex, text } = printerService.decodeNovitusResponse(
          result.packet.value,
        );
        setNovReply(hex);
        setNovReplyText(text);
      } else {
        setNovReply('(brak danych w odpowiedzi)');
        setNovReplyText('(brak danych w odpowiedzi)');
      }
      toast.success('Polecenie wysłane pomyślnie');
    } catch (err) {
      const errorMsg =
        err instanceof Error ? err.message : 'Błąd wysyłania polecenia';
      console.error('Error sending NOVITUS command:', err);
      toast.error(errorMsg);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Row className="mb-4">
      <Col lg={8}>
        <Card>
          <Card.Header>
            <Card.Title className="mb-0">Wysłanie polecenia NOVITUS</Card.Title>
          </Card.Header>
          <Card.Body>
            <p className="text-muted">
              Wyślij niestandardowe polecenie NOVITUS do drukarki.
            </p>

            <Form.Group className="mb-3">
              <Form.Label>Polecenie NOVITUS (bez znaczników)</Form.Label>
              <Form.Control
                as="textarea"
                rows={6}
                value={novCommand}
                onChange={e => setNovCommand(e.target.value)}
                placeholder="Wpisz polecenie i parametry (np. #v)"
                disabled={isLoading}
              />
              <Form.Text className="text-muted d-block mt-2">
                Wpisz tylko komendę i parametry. Znaczniki pakietu (ESC P, ESC
                \) i suma kontrolna będą obliczone i dodane automatycznie.
                <br />
                Użyj <code>&lt;CR&gt;</code>, <code>&lt;LF&gt;</code> lub{' '}
                <code>&lt;ESC&gt;</code> do wstawienia specjalnych znaków.
              </Form.Text>
            </Form.Group>

            <div className="d-flex gap-2 flex-wrap">
              <Button
                variant="primary"
                onClick={handleSend}
                disabled={isLoading || !novCommand.trim()}
              >
                {isLoading ? (
                  <>
                    <Spinner animation="border" size="sm" className="me-2" />
                    Wysyłanie...
                  </>
                ) : (
                  'Wyślij polecenie'
                )}
              </Button>
            </div>

            {novReply && (
              <>
                <Form.Group className="mt-4">
                  <Form.Label>Odpowiedź NOVITUS (hex)</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={4}
                    value={novReply}
                    readOnly
                    className="bg-light"
                    style={{ fontFamily: 'monospace', fontSize: '0.85rem' }}
                  />
                </Form.Group>

                <Form.Group className="mt-3">
                  <Form.Label>Odpowiedź NOVITUS (tekst)</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={4}
                    value={novReplyText}
                    readOnly
                    className="bg-light"
                    style={{ fontFamily: 'monospace' }}
                  />
                </Form.Group>
              </>
            )}
          </Card.Body>
        </Card>
      </Col>
    </Row>
  );
};
